module.exports = __webpack_public_path__ + "static/rollup-2212739f640df5c9ae1adfa5830b0313.jpg";